import { ApplicationConfig } from '@angular/core';
import { NavigationError, provideRouter, withInMemoryScrolling, withNavigationErrorHandler } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor, provideAuth } from 'angular-auth-oidc-client';
import { environment } from 'environments/environment';
import { browserSessionInterceptor } from './core/interceptors/browser-session.interceptor';
import { reloadAfterStaleDeployment } from './core/services/stale-deployment-recovery';

// Auth Config taken from:
// https://timdeschryver.dev/blog/configuring-angular-auth-oidc-client-with-the-new-functional-apis

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(
            routes,
            withInMemoryScrolling({
                scrollPositionRestoration: 'enabled',
                anchorScrolling: 'enabled'
            }),
            withNavigationErrorHandler((error: NavigationError) => {
                reloadAfterStaleDeployment(error.error);
            })
        ),
        provideHttpClient(
            withInterceptors([
                browserSessionInterceptor,
                authInterceptor()
            ])
        ),
        provideAuth({
            config: environment.authConfig,
        }),
    ]
};
